import React, { useState } from 'react';
import BusinessTaxAdvisoryPage from '@/components/BusinessTaxAdvisoryPage';
import Header from '@/components/Header/Header';
import validatePaidCampaign from '@helpers/validatePaidCampaign';
import FooterComponent from '@/components/Footer/FooterComponent';
import SEOHead from '@/components/SEOHead/SEOHead';
import { WordPressAPI } from '../../config';
import axios from 'axios';
import dynamic from 'next/dynamic';
import sanitizeHtml from 'sanitize-html';

const FooterNewsModal = dynamic(import('@/components/FooterNewsModal'));

const BusinessTaxAdvisory = ({ data }) => {
  const { acf } = data;
  const paid_campaign = validatePaidCampaign(acf.paid_campaign);
  const additional_questions = acf.additional_questions;
  const [hideSchedulerHeader, setHideSchedulerHeader] = useState(false);
  const scriptData = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [{
      "@type": "Question",
      "name": "Do I need a CPA for my small business?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Using a CPA is a competitive advantage, but you are free to handle that aspect of your business yourself. When you opt to work with the professionals at 1-800Accountant, you'll enjoy year-round tax preparation, tax organization and submission, and much more."
      }
    }, {
      "@type": "Question",
      "name": "How do I maximize my tax return for my small business?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Maximizing your tax savings is complex, time-consuming, and can open you up to harsh penalties and fees if you submit incorrect information. There isn't a specific method or formula that will maximize your savings, which is why so many small businesses turn to experts like 1-800Accountant."
      }
    }]
  })

  return (
    <div>
      <SEOHead>
        <title>{acf?.page_title_tag}</title>
        <meta
          name="description"
          content={acf?.meta_description || ''}
          key="description"
        />
        <script
          type="text/javascript"
          src="//app-ab33.marketo.com/js/forms2/js/forms2.min.js"
        />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: sanitizeHtml(scriptData) }} />
      </SEOHead>
      <Header
        AdditionalQuestions={additional_questions}
        PaidCampaign={typeof (paid_campaign) === 'undefined' ? 1 : paid_campaign}
        phone_number={acf.phone_number_setup}
        leadValues={acf.lead_values}
        hideSchedulerHeader={hideSchedulerHeader}
      />
      <BusinessTaxAdvisoryPage data={acf} setHideSchedulerHeader={setHideSchedulerHeader} />

      {/* Email Newsletter */}
      <FooterNewsModal />
      <FooterComponent phone_number={acf.phone_number_setup} />

    </div>

  )
}



export const getStaticProps = async () => {
  let pageNumber;
  if (WordPressAPI.pages.includes('marketing')) {
    pageNumber = '19160'
  } else {
    pageNumber = '19057'
  }
  const { data } = await axios.get(`${WordPressAPI.pages}/${pageNumber}`);

  return {
    props: {
      data,
    },
    // revalidate: 1,
  };
};

export default BusinessTaxAdvisory